import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SandboxService } from 'src/app/requests/esp/service/sandbox.service';
@Injectable()
export class SandboxInterceptor implements HttpInterceptor {
  constructor(private sandboxService: SandboxService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.sandboxService.isSandboxActive) {
      req = req.clone({
        setHeaders: { 'X-Sandbox': 'true' }
      });
    }
    return next.handle(req);
  }
}